import { Router } from '@angular/router';
import { Component, Input } from '@angular/core';

import { DoodProductModel } from '@core/models/product.model';
import { ProductKeys } from '@config/keys/product.keys';

import { RouterHelperService } from '@core/services/router-helper/router-helper.service';
import { AnalyticsService } from '@core/services/app/analytics.service';

@Component({
  selector: 'app-marketplace-category-horizontal',
  templateUrl: './marketplace-category-horizontal.component.html',
})
export class MarketplaceCategoryHorizontalComponent {
  @Input() products!: DoodProductModel[];
  @Input() id?: string;
  @Input() title?: string;

  constructor(
    private readonly router: Router,
    private readonly routerHelper: RouterHelperService,
    private readonly analyticsService: AnalyticsService,
  ) {}

  onNavigateTo(product: DoodProductModel): void {
    this.analyticsService.log({
      level: 'debug',
      label: '#DOOD-1250 Navigate',
      message: {
        from: 'MarketplaceCategoryHorizontalComponent Ligne°25',
        target: [
          this.routerHelper.translateRoute(
            `/products/${product[ProductKeys.ShopId]}/${product[ProductKeys.Id]}`,
          ),
        ],
        currentLocation: window.location.pathname,
      },
    });
    this.router.navigate([
      this.routerHelper.translateRoute(
        `/products/${product[ProductKeys.ShopId]}/${product[ProductKeys.Id]}`,
      ),
    ]);
  }
}
